import { ChargeLine } from '@msdyn365-commerce/retail-proxy';
import { EstimatedTaxOverrideValue } from '../themes/gardner-theme-b2c/views/order-confirmation.view';

export interface IChargeLinesBreakdownData {
    chargeLineLabel: string;
    chargeCode: string;
    isTaxableLine: boolean;
}

export const chargeLinesLogic = (
    chargeLines: IChargeLinesBreakdownData[] | undefined,
    currencyFormatter: (price: string | number, currencyCode?: string) => string,
    lines: ChargeLine[],
    renderLineChargeNode: (label: string, amount: string) => React.ReactNode,
    otherChargeTotal: number,
    estimatedTaxOverrideValue?: EstimatedTaxOverrideValue
): React.ReactNode[] => {
    let linesNode: React.ReactNode[] = [];

    chargeLines?.forEach(c => {
        const matched = lines.filter(l => l.ChargeCode === c.chargeCode && (l.CalculatedAmount ?? 0) >= 0.01);

        const totalForCode = matched.reduce((sum, l) => sum + (l.CalculatedAmount || 0), 0);
        if (totalForCode >= 0.01) {
            otherChargeTotal -= totalForCode;
            linesNode.push(renderLineChargeNode(c.chargeLineLabel, currencyFormatter(totalForCode.toString())));
        }
    });

    if (estimatedTaxOverrideValue && estimatedTaxOverrideValue.amount >= 0.01) {
        otherChargeTotal -= estimatedTaxOverrideValue.amount;
        linesNode.push(
            renderLineChargeNode(estimatedTaxOverrideValue.description, currencyFormatter(estimatedTaxOverrideValue.amount.toString()))
        );
    }

    if (otherChargeTotal >= 0.01) {
        linesNode.push(renderLineChargeNode('Other Charges', currencyFormatter(otherChargeTotal.toString())));
    }

    return linesNode;
};
